// extracted by mini-css-extract-plugin
export default {"editButton":"addAllowance_editButton__BCEMv","TableBody":"addAllowance_TableBody__zEF88","deleteButton":"addAllowance_deleteButton__+NF3i"};